import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ProductSiteRegionService } from '@app/services/product-site-region.service';
import { catchError, map, throwError } from 'rxjs';
import { TfErrorModel } from "@app/models/tf-error.model";

@Injectable({
    providedIn: 'root'
})
export class RelatedArrayCountService {

    constructor(private httpClient: HttpClient,
                private readonly productSiteRegionService: ProductSiteRegionService,) {}

  getRelatedArraysCount(productType: string, productSubtype: string, productId: string) {

    const url = `/api/magellan/product/relatedArrayCount`;

    const body = {
      productType: productType,
      productSubtype: productSubtype,
      keyword: productId,
      isFSCI: this.productSiteRegionService.isFisherSci()
    }

    return this.httpClient.post<any>(url, body).pipe(
      map(res => {
        if(!Object.prototype.hasOwnProperty.call(res, 'arrayCountMap')) {
          const jsonData = {}
          const productIds:string[] = productId.split(",")
          for (let i = 0; i < productIds.length; i++) {
            jsonData[productIds[i]] = 0
          }
          return JSON.stringify(jsonData)
        }
        return res.arrayCountMap
      }),
      catchError(err => {
        return throwError(() => new TfErrorModel(err.error.errorDetail.code, err.error.errorDetail.message))
      })
    );
  }
}
